/* eslint-disable @typescript-eslint/no-redeclare */
import { Static, Type } from '@sinclair/typebox';

import { JobPayload } from './job-payload.schema';

export type JobUpdatePayload = Static<typeof JobUpdatePayload>;
export const JobUpdatePayload = Type.Partial(
  Type.Omit(JobPayload, Type.Literal('taskId')),
);
